import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'psalterFilter', 
  pure: false
})

export class PsalterFilterPipe implements PipeTransform {
 
  transform(entities: any[], searchFilter: string, searchProofed: boolean): any[] {

   //console.log(searchFilter, searchProofed, entities);
  
    if (searchFilter === "" || searchFilter === undefined || searchFilter.length < 2) { 
      if (searchProofed === null) {
        return entities;
      } 
    }
 
    var results = this.filterByName(entities, searchFilter); 
    results = this.filterByProofed(results, searchProofed); 
    return results; 

   }

   private filterByName(entities: any[], searchTerm: string) { 
    if (searchTerm === undefined) {
      return entities;
    }

    searchTerm = searchTerm.toLowerCase();

    var results = entities.filter((entity) => {
      var matches = entity.AvailableSearchTerms.filter((s) => {
        if (s == null) return null;
       // console.log(s);
        s = s + ""; //tostring
        return (s.toLowerCase().indexOf(searchTerm) > -1)
      });

      return matches.length > 0;
    });

    return results;
   }

   private filterByProofed(entities: any[], searchProofed: boolean) {
     
      if (searchProofed === true) {
        var results = entities.filter((entity) => {
           return (entity.IsProofed === true);
        });
        
        return results;
      } 
      else if (searchProofed == false) {
        var results = entities.filter((entity) => {
           return (entity.IsProofed === false);
        });

        return results;
      } 
      else {
        return entities;
      }

   }
  

}
 